import { InputBase, InputLabel, Paper } from "@mui/material";
import { AppConstants } from "../../../constants/constant";
import { useFormContext } from "../../contexts/FormContext";
import { Field } from "../../../Interface/scheduler/form";
import "./InputTextWithButton.css";
import CurrentLocation from "../../../feature/inspection/components/CurrentLocation/CurrentLocation";
import React, { useEffect } from "react";
import { useErrorClassClassifier } from "../../hooks/useErrorClassClassifier";

interface InputTextProps {
  field: Field;
  error?: string;
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const InputTextWithButton = ({
  field,
  error,
  handleChange,
}: InputTextProps) => {
  const { formValues, setFormValues } = useFormContext();
  const inputId =
    field.id === AppConstants.EMAIL_ID || field.id === AppConstants.ZIPCODE_ID
      ? `agnos-${field.id}`
      : field.id;

  useEffect(() => {
    const sAddressParam = sessionStorage.getItem("sAddressParam");
    if (sAddressParam && sAddressParam !== "undefined") {
      setFormValues((prevValues) => ({
        ...prevValues,
        zipcode: sAddressParam,
      }));
    }
  }, []);

  return (
    <>
      <InputLabel className="label-basic">
        {field.label}
        {field.required === true && field.label && <sup>*</sup>}
      </InputLabel>
      <Paper
        component="form"
        className={useErrorClassClassifier({
          error: !!error?.length,
          errorClassToApply: "error-field-highlight",
          defaultClass: "inspection-wrapper",
        })}
        sx={{ display: "flex", alignItems: "center" }}
      >
        <InputBase
          name={field.id}
          id={inputId}
          sx={{ ml: 1, flex: 1 }}
          placeholder={field.placeholder}
          value={formValues[field.id] || ""}
          onChange={handleChange}
          aria-label={field.placeholder}
        />
        {field.useLocationCTA && (
          <CurrentLocation label={field.useLocationCTA} />
        )}
      </Paper>
      {error && <div className="error-message">{error}</div>}
    </>
  );
};
export default InputTextWithButton;
